import React from "react";
import { iconMap, iconColorMap } from "../../utils/iconMap.js";
const IconComponent = ({source, heading, size = 35 }) => {
    if(!source) return null;
    const Icon = iconMap[source][heading];
    const iconColor = iconColorMap[source][heading] || "black";
    return Icon ? (
            <Icon size={size} color={iconColor} />
        ):
        <></>;
};

export default IconComponent;
